module.exports = __webpack_public_path__ + "img/fronx-boostergreen.3ae776aa.svg";